import { useCallback, useRef } from 'react'
import { trackSectionView, type PageType } from './events'

// Returns a ref callback: attach to a section element to fire section_view once
// when it first enters the viewport.
export function useSectionView(pageType: PageType, section: string) {
  const seen = useRef(false)
  return useCallback(
    (el: HTMLElement | null) => {
      if (!el || seen.current || typeof IntersectionObserver === 'undefined') return
      const io = new IntersectionObserver((entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting && !seen.current) {
            seen.current = true
            trackSectionView({ pageType, section })
            io.disconnect()
          }
        }
      })
      io.observe(el)
    },
    [pageType, section],
  )
}
